import { render, staticRenderFns } from "./DebugView.vue?vue&type=template&id=4bcb8152&scoped=true&"
import script from "./DebugView.vue?vue&type=script&lang=js&"
export * from "./DebugView.vue?vue&type=script&lang=js&"
import style0 from "./DebugView.vue?vue&type=style&index=0&id=4bcb8152&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb8152",
  null
  
)

export default component.exports